export const locale = {
  lang: 'en',
  data: {
    SHORTCUT: {
      CLICK_TO_ADD: 'Click to add/remove shortcut',
      SEARCH_FOR_A_PAGE: 'Search for a page',
      NO_SHORTCUTS_YET: 'No shortcuts yet!',
    },
  },
};
